import {
  AgentDocument,
  DocsApiResult,
  DocumentFilter,
  FilterOption,
  GenerateApiResult,
  GeneratedLink,
} from './types';

const isErrorResponse = (payload: any) =>
  payload?.status === 'error' || payload?.success === false;

const getErrorMessage = (payload: any) =>
  String(
    payload?.errorMessage ||
      payload?.message ||
      payload?.errors?.[0]?.message ||
      'Something went wrong.',
  );

const toOption = (option: any): FilterOption => {
  if (typeof option === 'string' || typeof option === 'number') {
    const value = String(option);
    return { label: value, value };
  }

  return {
    label: String(option?.label ?? option?.name ?? option?.value ?? ''),
    value: String(option?.value ?? option?.code ?? option?.id ?? ''),
  };
};

const toOptions = (options: any[] = []): FilterOption[] =>
  options.map(toOption).filter((option) => option.label && option.value);

const toFilter = (filter: any): DocumentFilter => ({
  code: String(filter?.code ?? ''),
  label: String(filter?.label ?? filter?.code ?? ''),
  options: toOptions(filter?.options || []),
});

export const parseDocumentsApiResponse = (payload: any): DocsApiResult => {
  if (isErrorResponse(payload)) {
    return {
      documents: [],
      errorMessage: getErrorMessage(payload),
    };
  }

  const documents: AgentDocument[] = (payload?.documents || []).map(
    (doc: any) => ({
      id: String(doc?.id ?? ''),
      title: String(doc?.title ?? ''),
      description: String(doc?.description ?? ''),
      filters: (doc?.filters || [])
        .map(toFilter)
        .filter((item: DocumentFilter) => Boolean(item.code)),
    }),
  );

  return {
    documents,
    emptyMessage: documents.length ? '' : String(payload?.message || ''),
  };
};

export const parseGenerateApiResponse = (payload: any): GenerateApiResult => {
  if (isErrorResponse(payload)) {
    return {
      links: [],
      errorMessage: getErrorMessage(payload),
    };
  }

  const links: GeneratedLink[] = (payload?.links || [])
    .map((link: any) => ({
      label: String(link?.label ?? ''),
      url: String(link?.url ?? ''),
    }))
    .filter((link) => link.label && link.url);

  return {
    links,
    emptyMessage: links.length ? '' : String(payload?.message || ''),
  };
};
